module.exports = __webpack_public_path__ + "static/why-us-f9333a1bb6a6f50ab1bdb1c9f1818782.png";